import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import SectionHeader from "../../../../util/component/SectionHeader";
import { useQuery } from "@tanstack/react-query";
import DashboardTable from "./_components/dashboard-table/dashboard-table";
import { ReactQueryKey } from "../../types";
import { getRceDashboardList } from "../../api/services/getRceDashboardList";
import FilterBookings from "./_components/filter-bookings/FilterBookings";
import { useRecoilValue } from "recoil";
import { bookingsFilterState } from "../search/recoil";
import { useRceDashboardNumbersQuery } from "./api/getRceDashboardNumbers";
import { useEffect } from "react";

const RceDashboardPage = () => {

    const {t} = useTranslation('booking');
    const bookingsFilter = useRecoilValue(bookingsFilterState);
    useEffect(() => {
        console.log(bookingsFilter);
    }, [bookingsFilter])

    // const totalDashboardQuery = useQuery({
    //     queryKey: [ReactQueryKey.HeaderRceDashboard, { tenants: tenants || [], dealers: dealers || [] }],
    //     queryFn: () => getTotalBookingsDashboard({ tenants: tenants || [], dealers: dealers || [] })
    // });

    const tableQuery = useQuery({
        queryKey: [ReactQueryKey.RceDashboardList, { }],
        queryFn: () => getRceDashboardList({}),
        enabled: false,
    });

    const numbersQuery = useRceDashboardNumbersQuery({
        tenant: bookingsFilter?.tenants?.[0] || undefined
    });

    return (
        <>
            <SectionHeader title={t('label.bookingRceDashboard')} subtitle={
                <Stack direction="row" alignItems="center" columnGap={3}>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.callCenterPhone')}</Typography>
                        <Typography variant="h6">{numbersQuery.data?.callcenterphone}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.fleetPhone')}</Typography>
                        <Typography variant="h6">{numbersQuery.data?.fleetphone}</Typography>
                    </Stack>
                </Stack>
            }/>

            <Box px={2} pt={2}>
                <FilterBookings />
            </Box>
            <Box px={2} pt={2}>
                <DashboardTable />
            </Box>
        </>
    );
}

export default RceDashboardPage;
